import { useEffect, useCallback, useState } from 'react'
import { useConfigQuery } from '../app/zoomSdkQueries'
import { OnRunningContextChangeEvent, RunningContext } from '../types/sdk'

// sets up the zoomSdk and gets the running context
export const useGetRunningContext = () => {
  const { isLoading, data: config, refetch } = useConfigQuery('config')
  const [runningContext, setRunningContext] = useState<RunningContext>()

  // set it from the config
  useEffect(() => {
    if (config?.runningContext) setRunningContext(config?.runningContext)
  }, [config?.runningContext])

  // set it when it changes
  const fn = useCallback(
    ({ runningContext }: OnRunningContextChangeEvent) => {
      setRunningContext(runningContext)
      // if we aren't the same, refetch config
      if (config?.runningContext !== runningContext) {
        refetch()
      }
    },
    [config?.runningContext, refetch]
  )

  useEffect(() => {
    // prevent zoomSdk warning
    if (config) {
      try {
        zoomSdk.addEventListener('onRunningContextChange', fn)
      } catch {
        // do nothing to suppress warning
      }
    }

    return () => {
      if (config) zoomSdk.removeEventListener('onRunningContextChange', fn)
    }
  }, [fn, config])

  return { isLoading, runningContext, config }
}
